import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export function exportActivityTableToPdf(rows, title = 'Activity Report') {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  doc.setFontSize(14);
  doc.text(title, 14, 15);

  autoTable(doc, {
    startY: 22,
    head: [[
      'Date',
      'Member',
      'Teams',
      'Start Time',
      'Total Time',
      'Task Time',
      'Productive',
      'Neutral',
    ]],
    body: rows.map((row) => [
      row.date,
      row.member,
      row.teams,
      row.startTime,
      row.totalTime,
      row.taskTime,
      row.productive,
      row.neutral,
    ]),
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [0, 132, 254] },
    margin: { left: 14, right: 14 },
  });

  const stamp = new Date().toISOString().slice(0, 10);
  doc.save(`activity-report-${stamp}.pdf`);
}
